import React, { useEffect } from 'react';

import borrowBoxLogo from '../../img/BorrowBox_logo.png';
import './Maintenance.scss';
import { useTranslation } from 'react-i18next';
import { Button, ButtonSize, ButtonTheme } from '../shared/common/Button';
import { useMatch, useNavigate } from 'react-router-dom';

export const Maintenance = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const maintenanceMatch = useMatch('/maintenance');

    useEffect(() => {
        if (!maintenanceMatch) {
            const redirectTimeout = setTimeout(() => document.location.reload(), 60 * 1000);
            return () => clearTimeout(redirectTimeout);
        }
    }, [maintenanceMatch]);

    return (
        <div className="maintenance">
            <img src={borrowBoxLogo} />
            <p>{t('components.maintenance.description')}</p>
            <Button
                onClick={() => {
                    maintenanceMatch ? navigate('/') : document.location.reload();
                }}
                text={t('components.maintenance.refresh')}
                size={ButtonSize.LARGE}
                theme={ButtonTheme.POSITIVE_INVERT}
            />
        </div>
    );
};
